<div class="product-wrapper row justify-content-start">
  <div class="col-12 col-md-6 mb-2">
    <div class="product-box">
      <div class="info-box">
        <div class="product-wrapper">
          <div class="row no-gutters price-label">
            <div class="col-12">
              <div class="singleFund col-12">
                <div class="w-99 product-wrapper">
                  <!-- <kendo-dropdownlist
                    [formControl]="fundId"
                    [data]="currentUser?.marginTradeDetails"
                    [valuePrimitive]="false"
                    [valueField]="'customerCode'"
                    textField="customerName"
                    tabindex="1"
                    [popupSettings]="{ height: 200, 'z-index': 1000 }"
                  >
                    <ng-template kendoDropDownListValueTemplate let-dataItem>
                      <span class="template">{{ dataItem?.customerName }} [{{ dataItem?.customerCode }}]</span>
                      <span class="signed-acc-types">
                        <i class="far joint fa-handshake" [hidden]="dataItem.index === 0"></i>
                        <i class="ind fas fa-user-tie" [hidden]="dataItem.index !== 0"></i>
                      </span>
                    </ng-template>
                    <ng-template kendoDropDownListItemTemplate let-dataItem>
                      <span class="template"> {{ dataItem?.customerName }} [{{ dataItem?.customerCode }}] </span>
                      <span class="signed-acc-types">
                        <i class="far joint fa-handshake" [hidden]="dataItem.index === 0"></i>
                        <i class="ind fas fa-user-tie" [hidden]="dataItem.index !== 0"></i>
                      </span>
                    </ng-template>
                  </kendo-dropdownlist> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-6 mb-2">
    <div class="product-box">
      <div class="info-box">
        <div class="product-wrapper">
          <div class="row no-gutters ledger-info">
            <div class="col-12 pt-2 pb-3">
              <b>Balance</b>
              <span
                ><b>BDT {{ (portfolioData?.marketValueTotal && (portfolioData?.marketValueTotal | money)) || '0.00' }}</b></span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12 col-md-11 mb-2 mt-2">
    <ul class="sub-nav">
      <li [routerLinkActive]="['active']" [routerLink]="'/dashboard/ledger/portfolio/' + investerCode" routerLinkActive="active">
        <span>Portfolio</span>
      </li>

      <li [routerLinkActive]="['active']" [routerLink]="'/dashboard/ledger/summary/' + investerCode" routerLinkActive="active">
        <span>Summary</span>
      </li>
    </ul>
  </div>
</div>
<div class="card-1">
  <div [hidden]="!dataInProgress" class="loader text-center"></div>
  <div id="gridComponent" class="grid-container" *ngIf="portfolioPageGrid">
    <div class="grid-message p-a" [hidden]="portfolioPageGrid && portfolioPageGrid.gridQuery.total">
      <div [hidden]="!calsPortfolioGridInProgress" class="loader">loader</div>
      <p [hidden]="calsPortfolioGridInProgress">No Records Found.</p>
    </div>
    <kendo-grid
      *ngIf="portfolioPageGrid && portfolioPageGrid.gridQuery.total"
      [data]="portfolioPageGrid.gridView"
      [scrollable]="'none'"
      [skip]="portfolioPageGrid.gridQuery.skip"
      [sort]="portfolioPageGrid.gridQuery.sort"
      [pageSize]="portfolioPageGrid.gridQuery.take"
      [pageable]="portfolioPageGrid.pagination"
      (dataStateChange)="portfolioPageGrid.gridStateChanged($event)"
      [rowClass]="rowCallback"
    >
      <kendo-grid-column field="instrumentCode" title="Instrument Code" [headerClass]="'text-center'">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div style="white-space: nowrap" class="text-left">
            <span>{{ dataItem.instrumentCode }}</span>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column-group title="Quantity" [headerClass]="'text-center'">
        <kendo-grid-column field="totalStock" title="Total Qty">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div style="white-space: nowrap" class="text-end">
              <span>{{ dataItem.totalStock | number : 0 : false }}</span>
            </div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="saleable" title="Saleable Qty" [headerClass]="'text-center'">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div style="white-space: nowrap" class="text-end">
              <span>{{ dataItem.saleable | number : 0 : false }}</span>
            </div>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid-column-group>
      <kendo-grid-column field="avgCost" title="Average Cost" [headerClass]="'text-center'">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div style="white-space: nowrap" class="text-end">
            <span>{{ dataItem.avgCost | number : 2 : true }}</span>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="totalCost" title="Total Cost" [headerClass]="'text-center'">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div style="white-space: nowrap" class="text-end">
            <span>{{ dataItem?.totalCost | number : 2 : true }}</span>
          </div>
        </ng-template>
        <ng-template kendoGridFooterTemplate let-column="column">
          <div style="white-space: nowrap" class="text-end">
            <span>{{ calsPortfolioGridInProgress ? '' : (portfolioData?.totalCost | number : 2 : false) }}</span>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="marketRate" title="Market Rate" [headerClass]="'text-center'">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="text-end">
            <span>{{ dataItem.marketRate | number : 2 : true }} </span>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="marketValue" title="Market Value" [headerClass]="'text-center'">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="text-end">
            <span>{{ dataItem.marketValue | number : 2 : true }}</span>
          </div>
        </ng-template>
        <ng-template kendoGridFooterTemplate let-column="column">
          <div class="text-end">
            <span>{{ calsPortfolioGridInProgress ? '' : (portfolioData.marketValueTotal | number : 2 : false) }}</span>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="unrealizedGain" title="Unrealized Gain" [headerClass]="'text-center'">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div style="white-space: nowrap" class="text-end">
            <span>{{ dataItem.unrealizedGain | number : 2 : true }}</span>
          </div>
        </ng-template>
        <ng-template kendoGridFooterTemplate let-column="column">
          <div style="white-space: nowrap" class="text-end">
            <span>{{ calsPortfolioGridInProgress ? '' : (portfolioData.unrealizedGainTotal | number : 2 : false) }}</span>
          </div>
        </ng-template>
      </kendo-grid-column>
      <!--    <kendo-grid-column field="totalRealiseGainLoss" title="Realized Gain/(Loss)">-->
      <!--      <ng-template kendoGridCellTemplate let-dataItem>-->
      <!--        <div style="white-space: nowrap" class="text-right">-->
      <!--          <span>{{ dataItem.totalRealiseGainLoss | number: 2:true }}</span>-->
      <!--        </div>-->
      <!--      </ng-template>-->
      <!--    </kendo-grid-column>-->
      <kendo-grid-column field="gainPercentage" title="% Gain" [headerClass]="'text-center'">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div style="white-space: nowrap" class="text-end market-gain">
            <span>{{ dataItem.gainPercentage | number : 2 : true }}</span>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="marketValuePercentage" title="% Mkt. Value" [headerClass]="'text-center'">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div style="white-space: nowrap" class="text-end">
            <span>{{ dataItem.marketValuePercentage | number : 2 : true }}</span>
          </div>
        </ng-template>
        <ng-template kendoGridFooterTemplate let-column="column">
          <div style="white-space: nowrap" class="text-end">
            <span>100.00</span>
          </div>
        </ng-template>
      </kendo-grid-column>
      <ng-template kendoGridNoRecordsTemplate>
        <div class="loader">loader</div>
      </ng-template>
    </kendo-grid>
    <div *ngIf="portfolioData?.unrealizedGainTotal && !calsPortfolioGridInProgress" class="mb-2 mt-3">
      <div class="row portfolio-totals">
        <div class="col-12 text-end">Realized Gain/Loss <span> : </span>{{ portfolioData?.unrealizedGainTotal | number : 2 : false }}</div>
      </div>
      <button
        class="float-end mt-1 btn btn-fill ws-loading {{ downloadingReport ? 'ws-loading-progress' : '' }}"
        (click)="downloadReport('/account/me/financial/ledger-portfolio/export')"
      >
        Download Report
      </button>
    </div>
  </div>
</div>
